module.exports = __webpack_public_path__ + "img/Antikor_memo1.99b213c8.jpg";